import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './HomePage';
import TermsOfService from './TermsOfService';
import SplashScreen from './SplashScreen';
import './App.css';

function AppRoutes({ splashDone }) {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <>
      {isHome && !splashDone && null}
      <div style={{ visibility: splashDone || !isHome ? 'visible' : 'hidden' }}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/terms" element={<TermsOfService />} />
        </Routes>
      </div>
    </>
  );
}

function App() {
  const [splashDone, setSplashDone] = useState(false);

  return (
    <Router>
      {!splashDone && <SplashScreen onComplete={() => setSplashDone(true)} />}
      <AppRoutes splashDone={splashDone} />
    </Router>
  );
}

export default App;
